import { render, staticRenderFns } from "./form-notifications.vue?vue&type=template&id=706a1978&scoped=true"
import script from "./form-notifications.vue?vue&type=script&lang=js"
export * from "./form-notifications.vue?vue&type=script&lang=js"
import style0 from "./form-notifications.vue?vue&type=style&index=0&id=706a1978&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706a1978",
  null
  
)

export default component.exports